import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
import ResellersPage from "./pages/ResellersPage";
import HomeDashboard from "./pages/HomeDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import BusinessDetail from "./pages/BusinessDetail";
import SitePreview from "./pages/SitePreview";
import RegisterPage from "./pages/RegisterPage";
import Settings from "./pages/Settings";
import ContactDetailRedirect from "./pages/ContactDetailRedirect";
import ClientDashboard from "./pages/ClientDashboard";
import EditorPage from "./pages/EditorPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import ProfilePage from "./pages/ProfilePage";
import InboxPage from "./pages/InboxPage";
import AccountsPage from "./pages/AccountsPage";
import FinancePage from "./pages/FinancePage";
import ActivityLogPage from "./pages/ActivityLogPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import "./App.css";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes — no sidebar */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/resellers" element={<ResellersPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/pv/:slug" element={<SitePreview />} />
        {/* Legacy alias kept for backward compat with older emails/SMS */}
        <Route path="/preview/:slug" element={<SitePreview />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/client/:token" element={<ClientDashboard />} />
        <Route path="/editor/:token" element={<EditorPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />

        {/* Protected routes — wrapped in Layout (pathless wrapper) */}
        <Route element={<Layout />}>
          <Route path="/home" element={<HomeDashboard />} />
          <Route path="/pipeline" element={<AdminDashboard />} />
          <Route path="/business/:id" element={<BusinessDetail />} />
          {/* CRM merged into Pipeline — keep detail route for existing links */}
          <Route path="/crm" element={<Navigate to="/pipeline" replace />} />
          <Route path="/crm/:id" element={<ContactDetailRedirect />} />
          <Route path="/inbox" element={<InboxPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/accounts" element={<AccountsPage />} />
          <Route path="/finance" element={<FinancePage />} />
          <Route path="/activity-log" element={<ActivityLogPage />} />
          <Route path="/analytics" element={<Navigate to="/home" replace />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}
